/** Вызов из браузера после действий в админке (сессия NextAuth + роль admin в Strapi). */
export const revalidateMasterclassesFromAdmin = async (): Promise<void> => {
  const res = await fetch('/api/revalidate', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({}),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`revalidate ${res.status}: ${text}`);
  }
};
